module.exports = __webpack_public_path__ + "static/img/xqhz_5.76b2a5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xqhz/xqhz_5.png
// module id = Uc6a
// module chunks = 181